var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007F88",
    d: "M5.296 6.889s-.381.013-.367.034c.08.22.608 1.425.615 1.432c1.903.152 3.217.948 3.892 2.79H8.358l-.65 1.713s1.553-.002 1.728 0c-.54 1.726-2.046 2.735-3.827 2.735c-.076.179-.627 1.458-.6 1.467c3.085.358 5.996-1.92 6.278-4.202h1.375c0 .293.226.827.39 1.179c1 2.01 3.16 3.164 5.368 3.104c.362-.008.636-.052.622-.088l-.615-1.424c-1.738-.138-3.674-.834-4.058-2.77h1.08c.015 0 .595-1.715.595-1.715h-1.69c.602-1.821 2.238-2.755 4.117-2.781c0 0 .415-.939.6-1.418c-2.786-.522-5.941 1.32-6.416 4.2h-1.346c-.34-3.007-3.602-4.38-6.013-4.256"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.c0a2452711dfa1ae74f46d87c48c1a81.svg";
export { ForwardRef as ReactComponent };